'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type Control, type FieldValues, type Path, useController } from 'react-hook-form';
import { Checkbox } from '~/components/Checkbox';
import { richLink } from '~/components/Link';
import { isSingleOptInEnabled } from '~/utils/singleOptInFlag';
export function MarketingOptOutField(t0) {
  const $ = _c(12);
  const {
    control
  } = t0;
  let t1;
  if ($[0] !== control) {
    t1 = {
      name: "marketingOptOut" as Path<T>,
      control
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    field
  } = useController(t1);
  const t = useTranslations();
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = isSingleOptInEnabled();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const singleOptIn = t2;
  let t3;
  if ($[3] !== field) {
    t3 = e => field.onChange(e.target.checked);
    $[3] = field;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = singleOptIn ? t("content.forms.marketing_single_opt_out") : t("content.forms.marketing_opt_out");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== field.name || $[8] !== field.value || $[9] !== t3 || $[10] !== t4) {
    t5 = <Checkbox id="marketingOptOut" name={field.name} checked={field.value} onChange={t3} label={t4} aria-describedby={singleOptIn ? PRIVACY_NOTICE_ID : undefined} />;
    $[7] = field.name;
    $[8] = field.value;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export const PRIVACY_NOTICE_ID = 'privacy-notice';
export const privacyPolicyApplies = (consent: {
  newsletterSignup?: boolean;
  marketingOptOut?: boolean;
}): boolean => Boolean(consent.newsletterSignup) || !consent.marketingOptOut;
export function PrivacyNotice() {
  const $ = _c(6);
  const t = useTranslations();
  let t0;
  let t1;
  if ($[0] !== t) {
    const link = richLink("/privacy-policy", {
      target: "_blank"
    });
    t0 = PRIVACY_NOTICE_ID;
    t1 = isSingleOptInEnabled() ? t.rich("content.forms.marketing_single_notice", {
      link
    }) : t.rich("content.forms.privacy_notice", {
      link
    });
    $[0] = t;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = <p id={t0}>{t1}</p>;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}